import styled from 'styled-components';

export const EmailDisplay = styled('div')`
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  gap: 8px;
  background-color: #f2f2f2;

  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;

  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
`;

export const AuthMessage = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 16px;
`;

export const FormContainer = styled('section')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TitleAndDescriptionWrapper = styled('div')`
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const PhoneVerificationDisplay = styled('div')`
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  gap: 8px;
  background-color: #f2f2f2;

  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;

  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
`;
